
import { defineComponent, reactive } from 'vue'
import { Icon } from 'scvant';
import reportComfirmTitle from '../title.vue'

interface State {
    isShowMore: boolean;
}

export default defineComponent({
    name: 'reportItemConfig',
    setup() {
        let state: State = reactive({
            isShowMore: false
        });
        function showOrHide (){
            state.isShowMore = !state.isShowMore;
            // eslint-disable-next-line no-useless-escape
           
        }
        return {
            state,
            showOrHide
        }
    },
    components: {
        [Icon.name]: Icon,
        reportComfirmTitle
    },
    props: {
        renderData: {
            type: Object,
            default: () => {
                return {}
            }
        },
        options: {
            type: String,
            default: () => {
                return ''
            }
        }
    }
})
